import React from "react";
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import axios from 'axios';

import { whereBallsMove } from "../../helper";

export default class NewPassword extends React.Component {
    state = {
        id: null,
        errors: {},

        codeIsValid: false,
        checkCodeLoading: true,
        loading: false,
    }

    componentDidMount() {
        document.title = 'Fixfact';
        whereBallsMove(4);

        const {id} = this.props.match.params;

        if(!id) this.props.history.replace('/404');

        this.setState({
            id: id
        })

        let formData = new FormData();
        formData.append('t', id)
        this.checkCode(formData);
    }

    checkCode(params) {

        axios.post(`${window.siteUrl}/api/v1/user/restore_password_check_token/`, params)
        .then((response) => { 
            this.setState({
                codeIsValid: true,
                checkCodeLoading: false,
            });
        })
        .catch((error) => {
            this.setState({
                codeIsValid: false,
                checkCodeLoading: false,
            })
        });
    }

    handleSubmit(e, callback) {
        e.preventDefault();

        const pass = this.refs.pass.value.trim();
        const repass = this.refs.repass.value.trim();
        let newErrors = {};

        if(pass === '') {
            newErrors = Object.assign({}, newErrors, {pass: 'Объязательно для заполнения'});
        }

        if(repass === '') {
            newErrors = Object.assign({}, newErrors, {repass: 'Объязательно для заполнения'});
        }
        
        if(pass !== '' && repass !== '' && pass !== repass) {
            newErrors = Object.assign({}, newErrors, {non_field: 'Пароли не совпадают'});
        }

        this.setState({
            errors: newErrors,
        });

        if(Object.keys(newErrors).length > 0) {
            return false;
        }

        this.setState({
            loading: true,
        });

        let formData = new FormData();
        formData.append('t', this.state.id)
        formData.append('password', pass);

        axios.post(
            `${window.siteUrl}/api/v1/user/restore_password_set_password/`,
            formData
        )
        .then((response) => {
            this.refs.pass.value = '';
            this.refs.repass.value = '';

            this.setState({
                status: 'success',
                errors: {},
                loading: false
            });

            setTimeout(() => {
                this.props.history.replace('/signin')
            }, 1500);
        })
        .catch((error) => {
            this.setState({
                status: '',
                errors: error.response.data,
                loading: false
            })
        });
    }

    render() {

        const { errors, loading, status, checkCodeLoading, codeIsValid } = this.state;

        if(checkCodeLoading) return false;

        if(!codeIsValid) return <Redirect to="/404" />

        return (
            <div className="vertical-scrolling page fifthSection sectionSignUp" id="sectionSignUp" data-main-nav-id="signUpNavLink">
                <div className="container content">

                    <div className="left-content left-content-width" style={{justifyContent: "start"}}>
                        <div style={{position: "fixed", paddingTop: "260px"}}>
                            <h2 style={{marginTop: "0", maxWidth: "460px"}}>Восстановление <br/>пароля</h2>
                        </div>
                    </div>
    
                    <div className="right-content native-scroll right-content-bottom right-content-width">
                        <div className="screen-outer-block-wrap native-scroll menu-content">
                            <div className="menu-content-individual menu-content-item tab-parent screen-bottom-block">
                                <div className="rounded-white-block">
                                    <div className="white-block-content">
                                        <div className="sign-up-form-wrap">
                                            <form onSubmit={this.handleSubmit.bind(this)}>
                                                <input ref="pass" required type="password" placeholder="Новый пароль" className="width100"/>
                                                {
                                                    errors && errors.pass
                                                    ? <span className="input-error-text">{errors.pass}</span>
                                                    : null
                                                }

                                                <input ref="repass" required type="password" placeholder="Повторите новый пароль" className="width100"/>
                                                {
                                                    errors && errors.repass
                                                    ? <span className="input-error-text">{errors.repass}</span>
                                                    : null
                                                }
                                                {
                                                    errors && errors.non_field
                                                    ? <span className="input-error-text">{errors.non_field}</span>
                                                    : null
                                                }

                                                {
                                                    status === 'success' ?
                                                    <div className="input-error-text" style={{background:'#27ae60',fontSize: '14px',color:'#fff',marginBottom: '10px', padding: '7px'}}>
                                                        Операция прошла успешно! Будете перенаправлены на страницу авторизации.
                                                    </div>
                                                    : null
                                                }
                                                <div className="big-button button-action width100">
                                                    <button className={loading ? 'disabled' : ''}>Отправить</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Forgot/NewPassword.js